import React from 'react';
import Td from '@visa/vds/td';
import Tr from '@visa/vds/tr';
import MCSPagedTable from '../../../components/MCSPagedTable';
import Icon from '@visa/vds/icon';
import Badge from '@visa/vds/badge';
import {DateHelper} from '../../../_helpers/DateHelper';
import { useAuthContextUser } from '../../../context/AuthContext';

function ManageUsersTable(props){
    const user = useAuthContextUser();
    const canExport = user && (user.isSuperAdmin || user.hasReportingExport);
    const handleSearchChange = async (searchBy) =>{
        await props.fetch(1, searchBy,props.ordered,props.isDsc);
        props.setSelectedPage(1);
    }

    const sortData = async (orderBy = null , dsc = false) =>{
        await props.fetch(props.selectedPage,props.searchVal,orderBy,dsc);
    }

    const fetchDataOnPageChange = (page) =>{
        props.setSelectedPage(page);
        props.fetch(page,props.searchVal,props.ordered,props.isDsc);
    }

    return (
        <>
            <MCSPagedTable size={"compact"}
                colHeaders={props.colHeaders}
                useExportAll={canExport}
                handleExportAll={props.handleExportUsers}
                useSearchBar={true}
                usePagination={true}
                ordered={props.ordered}
                setOrdered={props.setOrdered}
                sortData={sortData}
                isDsc={props.isDsc}
                setDsc={props.setDsc}
                searchHelpText={"Search User ID/Name/Organization Name/BID"}
                searchVal = {props.searchVal} setSearchVal = {props.setSearchVal} handleSearchChange={handleSearchChange}
                selectedPage={props.selectedPage} setSelectedPage={fetchDataOnPageChange}totalPages={props.totalPages}
                tableData={
                    props.data && props.data.map((row,key)=>(
                    <Tr key={key}>
                        <Td>{row.volUserId} &nbsp; {row.isSubscriptionManager && <Badge type="stable">SM</Badge>}  &nbsp; {row.isAcquirerVmid && <Badge type="stable">VA</Badge>}  &nbsp; {row.isVmidParticipation && <Badge type="stable">VPF</Badge>}  &nbsp; {row.isVmidFileUpload && <Badge type="stable">VU</Badge>}</Td>
                        <Td>{row.fullName}</Td>
                        <Td>{row.organization.organizationName}</Td>
                        <Td>{row.organization.bid}</Td>
                        <Td>{row.organization.regionName ?? "-"}</Td>
                        <Td>{row.countryName}</Td>
                        <Td>{row.roleName}</Td>
                        <Td>{row.lastUpdatedBy}</Td>
                        <Td>{DateHelper.ToLocaleDateString(row.lastUpdatedOn)}</Td>
                        <Td>{user.entitleId >= row.entitleId && <Icon onClick={() => props.setSelectedUser(row)} className="vss-clickable-icon" name="settings" resolution="low" />}</Td>
                    </Tr>
                    ))
                }/>
        </>
    );
  }


export default ManageUsersTable;
